var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-select',{staticClass:"w-100",attrs:{"size":"mini","multiple":_vm.multiple,"clearable":""},model:{value:(_vm.selfActiveList),callback:function ($$v) {_vm.selfActiveList=$$v},expression:"selfActiveList"}},_vm._l((_vm.allList),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.key,"value":item.val}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }